import { SVGProps, memo } from "react";

const InvitePendingIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={props.width || "32"} height={props.height || "32"} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icon">
        <g id="Group 1501">
          <circle id="Ellipse 431" cx="15.8749" cy="16" r="11" stroke={props.stroke || "#0810FF"} strokeWidth={props.strokeWidth || "2"}/>
          <path id="Vector 677" d="M15.8749 8.19995V16H21.2749" stroke={props.stroke || "#0810FF"} strokeWidth={props.strokeWidth || "2"} strokeLinecap="round" strokeLinejoin="round"/>
        </g>
      </g>
    </svg>

  );
};

export default memo(InvitePendingIcon);
